import {Component, Input, Output, EventEmitter} from "@angular/core";
import {WatchService} from "../../services/watch.service";
import {DEF_INPUT_SIZE} from "../../enums/enums";
import {isUndefined} from "util";
import {getShortTimestamp} from "../../utils";

@Component({
    selector: "nv-datetime",
    templateUrl: "./nv-datetime.component.html"
})


export class NvDateTimeComponent {
    _label:string;
    _col:number;
    _document:any;
    _prop:string;


    @Input() set document(v: any) {
      this._document = v;
      this.setDate();
    }

    get document(){
      return this._document;
    }

    @Input() set prop(v:string){
      this._prop = v;
      this.setDate();
    };

    get prop(){
      return this._prop;
    }
    @Input() help:string;

    @Input() set label(v:string) { this._label = v; }
    @Input() set size(v:number) { this._col = v; }

    get label():string { return this._label || this._prop; }
    get size():number { return this._col || DEF_INPUT_SIZE; }

    @Output() update = new EventEmitter();

    timestampToDate:string = "";


    constructor(private watchService:WatchService) {

    }

    onDatePick(e) {
      this.document[this.prop] = getShortTimestamp(new Date(e));
      this.setDate();
      this.update.emit();
      this.watchService.notify();
    }

    setDate(){
      if (!isUndefined(this.document) && !isUndefined(this.prop))
      {
       // console.log(this.document[this.prop]);
        if (this.document[this.prop] == null)
        {
          this.document[this.prop] = getShortTimestamp(new Date());
        }
        this.timestampToDate = new Date(this.document[this.prop] * 1000).toString();
      }
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-datetime/nv-datetime.component.ts